import React from 'react';
import { Modal } from 'antd';
import classNames from 'classnames';
import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';
import { useDispatch } from 'react-redux';
import CampaignCreation from './components/CampaignCreation';
import CampaignCreationOnboarding from './components/CampaignCreationOnboarding';
import FolderCreation from './components/FolderCreation';
import { useTypedSelector } from '@hooks';
import { toggleCampaignFolderCreationModal } from '@redux/actions/modalAction';
import { CampaignFolderCreationModalProps } from '@redux/types/modalType';
import { useDebounced } from '@helpers/useDebounced';
import { useCampaignQuery } from '@hooks/queries/campaigns';

import './CampaignFolderCreationModal.less';

function CampaignFolderCreationModal({
  campaignId,
  parentId,
  entity,
  visible,
  createFromOnboarding,
  notShowCampaignCreatedModal,
  onFinish
}: CampaignFolderCreationModalProps) {
  const dispatch = useDispatch();

  const onCloseModal = () =>
    dispatch(
      toggleCampaignFolderCreationModal({
        visible: false,
        entity,
        createFromOnboarding
      })
    );

  const { data: campaign } = useCampaignQuery(
    { campaignId: campaignId || '' },
    { enabled: !!campaignId && visible && entity === 'folder' }
  );

  return (
    <Modal
      open={visible}
      footer={null}
      centered={true}
      width="auto"
      destroyOnClose
      closeIcon={<CrossSvg />}
      zIndex={1001}
      maskClosable={!createFromOnboarding}
      className={classNames(
        'campaign-folder-creation-modal tour-campaign-folder-creation-modal',
        {
          'is-onboarding': createFromOnboarding
        }
      )}
      onCancel={onCloseModal}
      afterClose={() => dispatch(toggleCampaignFolderCreationModal(null))}
    >
      {entity === 'folder' && !!campaign && (
        <FolderCreation
          campaign={campaign}
          parentId={parentId}
          onCloseModal={onCloseModal}
          handlerFinish={onFinish}
        />
      )}
      {entity === 'campaign' && !createFromOnboarding && (
        <CampaignCreation
          onCloseModal={onCloseModal}
          handlerFinish={onFinish}
          notShowCampaignCreatedModal={notShowCampaignCreatedModal}
        />
      )}
      {entity === 'campaign' && createFromOnboarding && (
        <CampaignCreationOnboarding onCloseModal={onCloseModal} />
      )}
    </Modal>
  );
}

export default function CampaignFolderCreationModalContainer() {
  const modalState = useTypedSelector(
    ({ modal }) => modal.campaignFolderCreationModal
  );
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible) return null;
  return <CampaignFolderCreationModal {...modalState} />;
}
